import { currentConfig } from '@/config';
import { filterMenu } from './filterMenu';

const categoriesUser = [
  {
    name: 'userWork',
    slug: 'user',
    view: ['computer', 'programs'],
    children: [
      { name: 'consolidated', route: 'consolidated', view: 'computer' },
      {
        name: 'worktime',
        route: 'worktime',
        view: 'computer',
        children: [
          { name: 'heatMap', route: 'heatMap', view: 'computer' },
          { name: 'worktimeDetails', route: 'worktimeDetails', view: 'computer' },
          { name: 'disciplineViolations', route: 'disciplineViolations', view: 'computer' },
        ],
      },
      { name: 'productivity', route: 'productivity', view: 'computer' },
      { name: 'appsTime', route: 'appsTime', view: ['computer', 'programs'] },
      { name: 'programs', route: 'programs', view: 'programs' },
      { name: 'activityFeed', route: 'activityFeed', view: ['computer', 'programs', 'visited-sites'] },
      { name: 'consolidatedFull', route: 'consolidatedFull', view: 'computer' },
      { name: 'summaryReport', route: 'summaryReport', view: 'computer' },
      { name: 'summaryUserReport', route: 'summaryUserReport', view: 'computer' },
      { name: 'files', route: 'files', view: 'files' },
    ],
  },
  {
    name: 'internet',
    slug: 'internet',
    view: ['visited-sites', 'messengers', 'web-mail'],
    children: [
      { name: 'websites', route: 'websites', view: 'visited-sites' },
      { name: 'messengers', route: 'messengers', view: 'messengers' },
      { name: 'mail', route: 'mail', view: 'web-mail' },
      {
        name: 'detailsMessengers',
        route: 'detailsMessengers',
        view: 'messengers',
      },
      {
        name: 'traffic',
        route: 'traffic',
        children: [
          { name: 'trafficByGroups', route: 'trafficByGroups' },
          { name: 'trafficDetailed', route: 'trafficDetailed' },
        ],
      },
    ],
  },
  {
    name: 'printers',
    slug: 'printers',
    view: 'printer',
    children: [
      { name: 'printerStatistics', route: 'printerStatistics', view: 'printer' },
      { name: 'employees', route: 'employees', view: 'printer' },
      { name: 'print', route: 'print', view: 'printer' },
    ],
  },
  {
    name: 'microphone',
    slug: 'microphone',
    view: 'webcams-and-microphones',
    children: [
      { name: 'microphoneSum', route: 'microphoneSum', view: 'webcams-and-microphones' },
      { name: 'microphoneDetails', route: 'microphoneDetails', view: 'webcams-and-microphones' },
    ],
  },
];

const reports = {
  name: 'reports',
  slug: 'reports',
  categories: categoriesUser,
};

const defaultMenu = [
  {
    name: 'data',
    slug: 'data',
    categories: [
      {
        name: 'view',
        slug: 'view',
        children: [
          { name: 'computers', route: 'computers' },
          { name: 'advanced', route: 'advanced' },
          { name: 'dashboard', route: 'dashboard' },
        ],
      },
      {
        name: 'notify',
        slug: 'notify',
        route: 'notifications',
      },
      {
        name: 'tasks',
        slug: 'tasks',
        route: 'tasks',
      },
      {
        name: 'search',
        slug: 'search',
        route: 'search',
      },
      {
        name: 'apps',
        slug: 'apps',
        route: 'remoteViewer',
        view: 'screenshots',
      },
    ],
  },
  reports,
  {
    name: 'security',
    slug: 'security',
    categories: [
      {
        name: 'relations',
        slug: 'relations',
        route: 'relations',
      },
      {
        name: 'watermark',
        slug: 'watermark',
        route: 'watermark',
      },
    ],
  },
  {
    name: 'control',
    slug: 'control',
    categories: [
      {
        name: 'settings',
        slug: 'settings',
        route: 'general',
      },
      {
        name: 'people',
        slug: 'people',
        route: 'controls',
      },
      {
        name: 'schedule',
        slug: 'schedule',
        route: 'schedule',
      },
      {
        name: 'diagnostics',
        slug: 'diagnostics',
        route: 'diagnostics',
      },
      {
        name: 'research',
        slug: 'research',
        route: 'agents',
      },
      {
        name: 'category',
        slug: 'category',
        route: 'category',
      },
      {
        name: 'printers',
        slug: 'printers',
        route: 'printPrice',
      },
      {
        name: 'sysLogs',
        slug: 'sysLogs',
        route: 'sysLogs',
      },
    ],
  },
  {
    name: 'program',
    slug: 'program3',
    categories: [
      {
        name: 'program',
        slug: 'program3',
        route: 'aboutProgram',
      },
      {
        name: 'refresh',
        slug: 'refresh',
        route: 'updatesProgram',
      },
    ],
  },
];

export const menu = filterMenu(defaultMenu, currentConfig.hiddenRoutes);
